import React from 'react';
import './AnnotationToolbar.css';

export type AnnotationTool = 'draw' | 'pin' | null;

const COLORS = ['#C2AC8E', '#7A93B5', '#1A1814'];
const WIDTHS = [2, 4];

interface AnnotationToolbarProps {
  activeTool: AnnotationTool;
  onToolChange: (tool: AnnotationTool) => void;
  color: string;
  onColorChange: (color: string) => void;
  strokeWidth: number;
  onStrokeWidthChange: (w: number) => void;
  canDraw: boolean;
  canPin: boolean;
  pathCount: number;
  onUndo: () => void;
  onDone: () => void;
}

export const AnnotationToolbar: React.FC<AnnotationToolbarProps> = ({
  activeTool,
  onToolChange,
  color,
  onColorChange,
  strokeWidth,
  onStrokeWidthChange,
  canDraw,
  canPin,
  pathCount,
  onUndo,
  onDone,
}) => {
  return (
    <div className="pa-toolbar">
      <div className="pa-toolbar-tools">
        {canDraw && (
          <button
            className={`pa-tool-btn ${activeTool === 'draw' ? 'pa-tool-btn--active' : ''}`}
            onClick={() => onToolChange(activeTool === 'draw' ? null : 'draw')}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <path d="M12 19l7-7 3 3-7 7-3-3z" />
              <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" />
              <path d="M2 2l7.586 7.586" />
            </svg>
          </button>
        )}
        {canPin && (
          <button
            className={`pa-tool-btn ${activeTool === 'pin' ? 'pa-tool-btn--active' : ''}`}
            onClick={() => onToolChange(activeTool === 'pin' ? null : 'pin')}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
          </button>
        )}
        {activeTool === 'draw' && pathCount > 0 && (
          <button className="pa-tool-btn pa-tool-btn--undo" onClick={onUndo}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <path d="M1 4v6h6" /><path d="M3.51 15a9 9 0 105.65-8.53" />
            </svg>
          </button>
        )}
      </div>

      {activeTool === 'draw' && (
        <div className="pa-toolbar-options">
          {COLORS.map(c => (
            <button
              key={c}
              className={`pa-color-dot ${c === color ? 'pa-color-dot--active' : ''}`}
              style={{ background: c }}
              onClick={() => onColorChange(c)}
            />
          ))}
          <div className="pa-toolbar-sep" />
          {WIDTHS.map(w => (
            <button
              key={w}
              className={`pa-width-btn ${w === strokeWidth ? 'pa-width-btn--active' : ''}`}
              onClick={() => onStrokeWidthChange(w)}
            >
              <span className="pa-width-preview" style={{ width: w * 2, height: w * 2 }} />
            </button>
          ))}
        </div>
      )}

      <button className="pa-done-btn" onClick={onDone}>
        Done
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
          <path d="M5 12h14M12 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
};
